<template>
  <div class="ui one column grid">
    <div class="column">
      <table class="ui celled very compact table">
        <thead v-if="columns.length > 0">
          <tr>
            <slot name="table-column">
            </slot>
            <th v-for="column in columns"
                :width="column.width"
                :classes="column.classes">
              {{ column.header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(object, index) in objects">
            <slot name="table-row-before" :row="object" :index="index"></slot>
            <td :width="objectProps.widths[propName]" v-for="(value, propName) in object">
              <div class="ui fluid transparent input">
                <input :type="objectProps.inputType[propName]"
                       :placeholder="objectProps.placeholder[propName]"
                       v-model="object[propName]">
              </div>
            </td>
            <!-- <slot name="table-row-after" :row="object" :index="index"></slot> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    objectArray: {
      type: Array,
      required: true
    },
    objectProps: {
      type: Object,
      default: () => { return {} }
    },
    columns: {
      type: Array,
      required: true
    },
    clearData: {
      type: Boolean,
      default: false
    },
    canAddObject: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      objects: [],
      isValidForm: true
    }
  },
  watch: {
    objects: {
      handler: function () {
        let lastObject = this.objects.length >= 1 ? this.objects[this.objects.length - 1] : null
        let beforeLastObject = this.objects.length > 1 ? this.objects[this.objects.length - 2] : null

        if (lastObject && this.objectPropHasValue(lastObject)) {
          this.addMultiObjects(1)
        }

        if (beforeLastObject && !this.objectPropHasValue(beforeLastObject)) {
          this.objects.splice(this.objects.length - 1, 1)
        }

        let returnedData = window._.cloneDeep(this.objects)
        returnedData.splice(returnedData.length - 1, 1)

        this.isValidForm = returnedData.every(object => {
          return this.objectPropHasValue(object)
        }) || !returnedData.length

        this.$emit('onChange', {
          data: returnedData,
          isValid: this.isValidForm
        })
      },
      deep: true
    },
    clearData: function () {
      if (this.clearData) {
        this.objects = []
        this.addMultiObjects(1)
      }
    }
  },
  mounted () {
    if (this.objects.length === 0) {
      this.objects = this.objectArray
    }
  },
  methods: {
    addMultiObjects (numberOfObjects) {
      if (this.canAddObject) {
        for (var i = 0; i < numberOfObjects; ++i) {
          let newObject = {}
          window._.forEach(this.objectProps.baiscProps, prop => {
            newObject[prop.name] = prop.defaultValue
          })
          this.objects.push(newObject)
        }
      }
    },
    objectPropHasValue (object) {
      return window._.values(object).every(value => { return value })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/abstract_components/InputTable.vue